<template>
  <div style="width:1000px; margin:0 auto"> 

 <!-- <img style="width:100%;margin:0" src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20230721/user-0/20230721/c239bbb76dfd0c966fe0ba30aba1742f.jpg?x-oss-process=style/tb-750" /> -->
    <!-- <img style="width:100%;margin:0" src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20230721/user-0/20230721/492a9c3d8220166be1810f9ecfc19648.jpg?x-oss-process=style/tb-750" /> -->
  <div style="text-align:center;font-size:20px;color:#333;margin-top:100px">系统维护中...</div>
  </div>
</template>
<script> 

export default {
  name: "IndexIndex",
  data() {
    return {  
      }
  },
  mounted() {
    // this.getnotice();
    // this.getcourse();

    document.title = "全国跳绳推广委员会 毽球跳绳官方网站"
    document.querySelector('meta[name="description"]').setAttribute('content','全国跳绳推广委员会是国家体育总局社会体育指导中心授权成立的专门负责全国跳绳运动推广的组织机构。下设教练员、裁判员、竞赛、段位制、科研、宣传推广等委员会。')
    
  },
  filters: { 
  },
  methods: { 
  },
  components: { 
  },
};
</script>
<style lang="scss" scoped> 
</style>



// WEBPACK FOOTER //
// IndexUpdate.vue?5be22cdb